<template>
  <div class="l-container confirm-info mx-auto">
    
    <div class="main-content flex">
      <div class="left-content m-4">
        <LeftNoti />
      </div>
      <div class="right-content">
        <div class="top-title ml-2">
          <h3>お知らせ一覧</h3>
        </div>
        <div class="mt-6 mb-6 mx-4 divider"></div>
        <div class="c-box m-4 pr-0">
          <div class="p-information">
              <div class="p-information__main">
                <div class="p-information__inner">
                  <div
                    class="p-information__paginator p-information__paginator--separate p-information__paginator_sp-none"
                  >
                    <div class="p-information__back__button p-information__button__none">
                      <i class="icon icon-bor-arrow-left" ></i>
                      <TextButton
                        position="left"
                        size="sm"
                        color="red"
                        to="/notifications"
                        :class="{
                          'p-information__button__disabled':
                            isDisabledPrev || isDisabledBtn,
                        }"
                        class="p-information-detail__toHome"
                        @click.native="decrementPage"
                      >
                        前へ
                      </TextButton>
                    </div>
                    <div class="p-information__next__button p-information__button__none">
                      <TextButton
                        position="right"
                        size="sm"
                        color="red"
                        to="/notifications"
                        :class="{
                          'p-information__button__disabled':
                            isDisabledNext || isDisabledBtn,
                        }"
                        class="p-information-detail__toHome"
                        @click.native="incrementPage"
                      >
                        次へ
                        <i class="icon icon-bor-arrow-right" ></i>
                      </TextButton>
                    </div>
                  </div>

                  <ul class="p-information__lists" v-if="this.infoList.length">
                    <li
                      class="p-information__list"
                      v-for="item in infoList"
                      :key="item.id"
                    >
                      <div class="p-information__list__wrap" @click="showDetail(item.id)">
                        <article class="p-information__list__content">
                          <div class="p-information__list__tags">
                            <p class="p-information__list__date" v-if="item.pub_date">
                              {{ formatDate(item.pub_date) }}
                            </p>
                            <p class="p-information__list__tag">
                              {{ item.news_type_name }}
                            </p>
                          </div>
                          <router-link to="" class="p-information__list__title one-lines-ellipsis">
                            {{ item.display_title }}
                          </router-link>
                        </article>
                      </div>
                    </li>
                  </ul>
                  <ul v-else>
                    <li class="p-information__no__list">
                      該当するお知らせはありません。
                    </li>
                  </ul>

                  <div
                    class="p-information__paginator p-information__paginator_sp-padding"
                  >
                    <div class="p-information__back__button">
                      <i class="icon icon-bor-arrow-left" ></i>
                      <TextButton
                        position="left"
                        size="sm"
                        color="red"
                        to="/notifications"
                        :class="{
                          'p-information__button__disabled':
                            isDisabledPrev || isDisabledBtn,
                        }"
                        class="p-information-detail__toHome"
                        @click.native="decrementPage"
                      >
                        前へ
                      </TextButton>
                    </div>
                    <div class="p-information__next__button">
                      <TextButton
                        position="right"
                        size="sm"
                        color="red"
                        to="/notifications"
                        :class="{
                          'p-information__button__disabled':
                            isDisabledNext || isDisabledBtn,
                        }"
                        class="p-information-detail__toHome"
                        @click.native="incrementPage"
                      >
                        次へ
                        <i class="icon icon-bor-arrow-right" ></i>
                      </TextButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TextButton from './components/TextButton'
import LeftNoti from './components/LeftNoti'
import moment from 'moment'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import _ from 'lodash'

export default {
  name: 'BS_INF_01_001',
  components: {
    TextButton, 
    LeftNoti
  },
  data() {
    return {
      currentPage: 1,
      infoList: [],
      categoryWord: '',
      newsTypeId: '',
      year: '',
      controlPagination: {},
      isDisabledBtn: false,
      breadcrumbs: [],
      
      breadcrumb_data: ['トップ', 'お知らせ一覧'],
      is_hidden: true,
      windowHeight: null,
      date: '2020.04.02',
      label: 'サービスについて',
      title: 'デジタルクーポンコード・デジタルチケットプランのご利用停止と再開目処について'
    }
  },

  computed: {
    changeStoreCategory() {
      return (
        this.$store.state.bs_inf.information.categoryName ||
        this.$store.state.bs_inf.information.categoryYear
      )
    },
    isDisabledPrev() {
      return !this.controlPagination.prev
    },
    isDisabledNext() {
      return !this.controlPagination.next
    }
  },
  methods: {
    async getList(newsTypeId, year) {
      const params = {
        newsTypeId,
        year,
        Page: this.currentPage
      }
      const res = await this.$repositories('cms').getNews({ params })
      this.infoList = res.data.objects[0].data
      this.controlPagination = res.data.objects[0].links
    },
    showDetail(id) {
      this.$router.push({ path: `/notifications/${id}`})

    },
    formatDate(item) {
      return moment(item).format('YYYY年MM月DD日')
    },
    incrementPage() {
      this.isDisabledBtn = true
      this.currentPage++
      this.getList().then(() => {
        this.isDisabledBtn = false
      })
    },
    decrementPage() {
      this.isDisabledBtn = true
      this.currentPage--
      this.getList().then(() => {
        this.isDisabledBtn = false
      })
    },
    /**
     * パンくずリスト作成
     */
    setBreadcrumb() {
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  async mounted() {
    this.currentPage = 1
    this.year = this.$store.state.bs_inf.information.categoryYear
    this.newsTypeId = this.$store.state.bs_inf.information.categoryName
    this.getList()

    // update breadcrumbs
    const mybreadcrumbs = 
    {
      path: '/notifications',
      title: 'お知らせ一覧'
    }
    this.breadcrumbs.push(mybreadcrumbs)
    this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)

    window.addEventListener('resize', () => {
      this.windowHeight = window.innerWidth
    })
  },
  watch: {
    $route() {
      this.setBreadcrumb()
      this.getList()
    },
    changeStoreCategory() {
      this.currentPage = 1
      this.year = this.$store.state.bs_inf.information.categoryYear
      this.newsTypeId = this.$store.state.bs_inf.information.categoryName
      this.getList()
    },

    year() {
      this.getList('', this.year)
    },

    newsTypeId() {
      this.getList(this.newsTypeId, '')
    },

    windowHeight () {
      if(this.windowHeight > 768) {
        this.is_hidden = true
      }else{
        this.is_hidden = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>